<template>
  <div class="footer-w footer-w_pt bg1">
    <div class="container">
      <div class="coh">

        <img
          src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/66a8fd03578b1593429dac04_ti_logo.svg"
          loading="lazy" alt="" class="ft-l">


      </div>
      <div class="coh">
        <img
            src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/647f7f5942fdebf04d783069_bh.png"
            loading="lazy" alt="" class="ft-l">
        <img src="/img/cp/logo_starr_transparent.png" alt="logo starr" data-v-6ce6bd02="" width="270px" style="position: relative; top: -10px;">
      </div>
      <div class="copy">

        <div>
          <a href="/files">Informácie o rozsahu poistenia</a><br />
          © 2024 Travel insurance. <br>Všetky práva vyhradené.</div>
      </div>
    </div>
  </div>
  <!-- cookie warning toast -->
  <div :class="{ 'toast':true, 'show': show,  'bg-light w-20 mw-20': true, 'cookie-popup': true }">
    <div  role="alert" data-autohide="false">

      <div class="toast-body p-4 d-flex flex-column">
        <h4>{{ $t("cookies.title") }}</h4>
        <p>
          {{ $t("cookies.subtitle") }}
        </p>
        <div class="ml-auto">
          <!--          <button type="button" class="btn btn-outline-light mr-3" id="btnDeny">-->
          <!--            Deny-->
          <!--          </button>-->
          <button type="button" class="btn btn_trv w-inline-block" @click="save(1)">
            {{ $t("cookies.button") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieLaw from 'vue-cookie-law'
export default {
  name: "FooterPart",
  components: {

  },
  data: function (){
    return { show: false}
  },
  props: {
    product: String
  },
  methods: {
    save(val){
      localStorage.setItem('cookies', val);
      this.show = false;
    }
  },
  mounted() {
     this.show = !localStorage.getItem('cookies');
  }
}
</script>
<style>
.cookie-popup{
  display: none;
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: white;
  z-index: 10;
  padding: 15px;
  font-size: 0.9em;
  border: 1px solid var(--blue);
  max-width: 400px;
}

.cookie-popup.show{
  display: block;
}

.copy a{
  text-decoration: none;
  display: block;
  margin-bottom: 0px;
  font-size: 1.25em;
  position: relative;
  top: 0px;

}

.coh{
  flex-wrap: wrap;
  row-gap: 1.5em;
}



</style>

